import { render, staticRenderFns } from "./test-nested.vue?vue&type=template&id=7af2e906&scoped=true&"
import script from "./test-nested.vue?vue&type=script&lang=js&"
export * from "./test-nested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2e906",
  null
  
)

export default component.exports